import * as React from 'react';
import { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import styles from './CategoryFacets.module.scss';
import type { Facet, FacetItem } from '../../stores/types';

export interface FacetProps {
  facet: Facet;
  expanded: boolean;
  onFacetChange: (item: FacetItem) => any;
  idPrefix: string;
}

const Facet = ({ facet, expanded = false, onFacetChange, idPrefix }: FacetProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(expanded);

  return (
    <div className={`${styles.CategoryFacetsFilter} px-3 px-lg-0`} key={facet.type.code} data-testid="CategoryFacets:Facet">
      <a
        className={styles.CategoryFacetsFilterToggle}
        data-toggle="collapse"
        role="button"
        aria-expanded={isExpanded}
        aria-controls={`facet-${facet.type.code}`}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className={styles.FacetToggleValue}>{facet.type.value}</span>
      </a>

      <Collapse in={isExpanded}>
        <div className={styles.FacetValuesList} id={`${idPrefix}-${facet.type.code}`}>
          <ul className={`${styles.FacetList} mb-3`}>
            {facet.items.map((item) => {
              return (
                <li className="w-100" key={item.value.code}>
                  <label className={styles.FacetLabel} role="button">
                    <input
                      className={`${styles.facetCheckbox} mr-1`}
                      type="checkbox"
                      value={item.urlSet?.api}
                      onChange={() => onFacetChange(item)}
                      checked={item.selected}
                      data-urlset-api={item.urlSet.api}
                      data-urlset-web={item.urlSet.web}
                    />
                    <span className={styles.FacetLabelValue}> {item.value.value}</span>
                    <span>({item.hits})</span>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      </Collapse>
    </div>
  );
};

export interface CategoryFacetsProps {
  facets: Facet[];
  isOpen?: boolean;
  onFacetChange: (arg0: FacetItem) => void;
  productCount?: number;
  toggleFacetsOpen?: () => void;
  idPrefix?: string;
}

export const CategoryFacets = ({ facets, isOpen, onFacetChange, idPrefix = 'facet' }: CategoryFacetsProps) => {
  const handleFacetChange = async (facetItem: FacetItem) => {
    onFacetChange(facetItem);
  };

  return (
    <div className={`${styles.CategoryFacets} ${isOpen ? styles.isOpen : ''}`} data-testid="catalog:category-facets">
      {facets?.map((facet: any) => {
        const hasExpandedItem: boolean = facet.items.findIndex((item: FacetItem) => item.selected === true) > -1;

        return (
          <Facet facet={facet} expanded={hasExpandedItem} onFacetChange={handleFacetChange} key={facet.type.code} idPrefix={idPrefix} />
        );
      })}
    </div>
  );
};
